import gql from 'graphql-tag';

export default gql`
  fragment projectTagFragment on ProjectTag {
    id
    clientId
    uuid
    name
    color
  }
`;
